import { MDText } from 'i18n-react';
import { z, ZodIssueCode } from 'zod';

import { getZodFormErrorCodes } from 'Services/zod.helpers';
import { numberWithCommas } from 'Utilities/helpers';

import { BidInputSchema } from './bidInput.schema';
import LocalTexts from './ProxyBidActions.texts';

const LocalT = new MDText(LocalTexts);

export const validateBidInput =
	(minimumBidValue: number) =>
	(value: string): string | undefined => {
		if (!value) {
			return `${LocalT.translate('validationErrors.genericBid')}`;
		}

		const parsedInputWithMinimumBid = BidInputSchema.pipe(z.number().min(minimumBidValue)).safeParse(value);

		if (parsedInputWithMinimumBid.success) {
			return undefined;
		}

		const isBidTooSmall = getZodFormErrorCodes(parsedInputWithMinimumBid.error).includes(ZodIssueCode.too_small);

		if (isBidTooSmall) {
			return `${LocalT.translate('validationErrors.minimumBidAmountProxy', {
				minimum: numberWithCommas(minimumBidValue),
			})}`;
		}

		return `${LocalT.translate('validationErrors.genericBid')}`;
	};
